import React from "react";
import InputGroup from 'react-bootstrap/InputGroup';
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import NumberBox from "../../elements/NumberBox";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import VIEW_MODE from '../../common.js';

export default function CriticalShearStressOptions(props) {
  const parameters = props.parameters;
  const handleTextBoxOnChange = props.handleTextBoxOnChange;
  const view_mode = props.view_mode;

  function getTauCOuterLabel() {
    return (
      <p style={{ "margin": 0 }}>
        Outer User Defined &tau;<span style={{ fontSize: "0.6em", verticalAlign: "bottom" }} >c</span>
      </p>
    );
  }
  function getTauCInnerLabel() {
    return (
      <p style={{ "margin": 0 }}>
        Inner User Defined &tau;<span style={{ fontSize: "0.6em", verticalAlign: "bottom" }} >c</span>
      </p>
    );
  }

  function getSigmaD50Sed(location) {
    return (
      <span>
        {location} &sigma;<span className="supsub"><sub>&tau;<span className="supsub">
          <sub>c</sub>
        </span> </sub> </span>
      </span>
    );
  }

  function getInfoLabel() {
    return (
      <p style={{ "margin": 0 }}>
        Standard deviation for user defined &tau;<sub>c</sub>
      </p>
    );
  }


  function getSedimentLabel(extra) {
    return (
      <span>
        {extra} D<span className="supsub">
          <sup>bank</sup>
          <sub>50</sub>
        </span>
      </span>
    );
  }

  return (
    <Card>
      <Card.Header>Critical Shear Stress</Card.Header>
      <Card.Body>
        <Container>

          <Row>
            <Col md={6} sm={12}>
              <Form.Group controlId={"criticalShearStressOptions"}>
                <Form.Label>Model</Form.Label>
                <Form.Control
                  name="criticalShearStressModel"
                  as="select"
                  value={parameters["criticalShearStressModel"]}
                  onChange={handleTextBoxOnChange}
                >
                  {view_mode == VIEW_MODE.ADVANCED && <option value="brownlie">Brownlie (1981)</option>}
                  <option value="paphitis">Paphitis (2001)</option>
                  <option value="userDefined">User Defined</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6} sm={12}>
              {parameters["criticalShearStressModel"] === "userDefined" &&
                <Form.Group controlId={"userDefinedTauCOptionsInner"}>
                  <Form.Label>{getTauCInnerLabel()}</Form.Label>
                  <div style={{ "position": "relative" }}>
                    <InputGroup>
                      <Form.Control
                        name="criticalShearStressUserDefinedPaInner"
                        as="select"
                        value={parameters["criticalShearStressUserDefinedPaInner"]}
                        onChange={handleTextBoxOnChange}
                        style={{ "position": "relative" }}
                      >
                        <option value="0.47">2% Silt-clay (0.47 Pa)</option>
                        <option value="1.06">5% Silt-clay (1.06 Pa)</option>
                        <option value="2.14">10% Silt-clay (2.14 Pa)</option>
                        <option value="4.59">20% Silt-clay (4.59 Pa)</option>
                        <option value="7.33">30% Silt-clay (7.33 Pa)</option>
                        <option value="10.20">40% Silt-clay (10.20 Pa)</option>
                        <option value="13.07">50% Silt-clay (13.07 Pa)</option>
                        <option value="15.80">60% Silt-clay (15.80 Pa)</option>
                        <option value="18.25">70% Silt-clay (18.25 Pa)</option>
                        <option value="20.27">80% Silt-clay (20.27 Pa)</option>
                        <option value="21.73">90% Silt-clay (21.73 Pa)</option>
                        <option value="22.49">100% Silt-clay (22.49 Pa)</option>
                      </Form.Control>
                      <Form.Control
                        type="number"
                        name="criticalShearStressUserDefinedPaInnerCustom"
                        onChange={handleTextBoxOnChange}
                        style={{ "position": "absolute", "top": "0px", "left": "0px", "right": "65px", "width": "auto" }}
                        value={parameters["criticalShearStressUserDefinedPaInner"]}
                        step="0.01"
                      >
                      </Form.Control>

                      <InputGroup.Append>
                        <InputGroup.Text>Pa</InputGroup.Text>
                      </InputGroup.Append>

                    </InputGroup>
                  </div>
                </Form.Group>
              }
            </Col>
            <Col md={6} sm={12}>
              {parameters["criticalShearStressModel"] === "userDefined" &&
                <Form.Group controlId={"userDefinedTauCOptionsOuter"}>
                  <Form.Label>{getTauCOuterLabel()}</Form.Label>
                  <div style={{ "position": "relative" }}>
                    <InputGroup>
                      <Form.Control
                        name="criticalShearStressUserDefinedPaOuter"
                        as="select"
                        value={parameters["criticalShearStressUserDefinedPaOuter"]}
                        onChange={handleTextBoxOnChange}
                        style={{ "position": "relative" }}
                      >
                        <option value="0.47">2% Silt-clay (0.47 Pa)</option>
                        <option value="1.06">5% Silt-clay (1.06 Pa)</option>
                        <option value="2.14">10% Silt-clay (2.14 Pa)</option>
                        <option value="4.59">20% Silt-clay (4.59 Pa)</option>
                        <option value="7.33">30% Silt-clay (7.33 Pa)</option>
                        <option value="10.20">40% Silt-clay (10.20 Pa)</option>
                        <option value="13.07">50% Silt-clay (13.07 Pa)</option>
                        <option value="15.80">60% Silt-clay (15.80 Pa)</option>
                        <option value="18.25">70% Silt-clay (18.25 Pa)</option>
                        <option value="20.27">80% Silt-clay (20.27 Pa)</option>
                        <option value="21.73">90% Silt-clay (21.73 Pa)</option>
                        <option value="22.49">100% Silt-clay (22.49 Pa)</option>
                      </Form.Control>
                      <Form.Control
                        type="number"
                        name="criticalShearStressUserDefinedPaOuterCustom"
                        step="0.01"
                        onChange={handleTextBoxOnChange}
                        style={{ "position": "absolute", "top": "0px", "left": "0px", "right": "65px", "width": "auto" }}
                        value={parameters["criticalShearStressUserDefinedPaOuter"]}
                      >

                      </Form.Control>
                      <InputGroup.Append>
                        <InputGroup.Text>Pa</InputGroup.Text>
                      </InputGroup.Append>

                    </InputGroup>
                  </div>
                </Form.Group>
              }
            </Col>
          </Row>


          <Row>

            {parameters["criticalShearStressModel"] !== "userDefined" &&
              <Col md={6} sm={12}>
                <NumberBox
                  label={getSedimentLabel("Inner")}
                  controlId="d50SedimentInner"
                  info="Mean sediment diameter for the bank"
                  unit="mm"
                  name="d50Inner"
                  value={parameters.d50Inner}
                  onChange={handleTextBoxOnChange}
                />
              </Col>}

            {parameters["criticalShearStressModel"] !== "userDefined" &&
              <Col md={6} sm={12}>
                <NumberBox
                  label={getSedimentLabel("Outer")}
                  controlId="d50SedimentOuter"
                  info="Mean sediment diameter for the bank"
                  unit="mm"
                  name="d50Outer"
                  value={parameters.d50Outer}
                  onChange={handleTextBoxOnChange}
                />
              </Col>
            }
          </Row>
          <Row>

            {parameters["criticalShearStressModel"] !== "paphitis" &&
              <Col md={6} sm={12}>
                <NumberBox
                  label={getSigmaD50Sed("Inner")}
                  controlId="d50SedimentInnerSD"
                  info={getInfoLabel()}
                  unit="Pa"
                  step="0.0001"
                  name="tauCInnerSD"
                  value={parameters.tauCInnerSD}
                  onChange={handleTextBoxOnChange}
                />
              </Col>
            }

            {parameters["criticalShearStressModel"] !== "paphitis" &&
              <Col md={6} sm={12}>
                <NumberBox
                  label={getSigmaD50Sed("Outer")}
                  controlId="d50SedimentOuterSD"
                  info={getInfoLabel()}
                  unit="Pa"
                  step="0.0001"
                  name="tauCOuterSD"
                  value={parameters.tauCOuterSD}
                  onChange={handleTextBoxOnChange}
                />
              </Col>
            }
          </Row>
        </Container>
      </Card.Body>
    </Card >
  );
}

